import React from 'react';
import {
  Box,
  Heading,
  VStack,
  Text,
  SimpleGrid,
  Image,
  Tag,
  useToast,
} from '@chakra-ui/react';

export const ResourceCenter = () => {
  const resources = [
    {
      title: 'Diabetes Management Guide',
      category: 'Health Guide',
      desc: 'Expert tips on managing your sugar levels through diet and exercise.',
      image: '/Labs.jpg',
    },
    {
      title: 'Understanding Blood Reports',
      category: 'Lab Knowledge',
      desc: 'A complete guide to understanding what those numbers mean.',
      image: '/Labs2.jpg',
    },
    {
      title: 'Monsoon Illness Prevention',
      category: 'Wellness',
      desc: 'Stay safe from viral infections this rainy season.',
      image: '/Labs.jpg',
    },
  ];

  const toast = useToast();

  return (
    <Box bg="gray.50" minH="100vh">
      <VStack spacing={12} py={20} px={[5, 10, 20]}>
        <VStack spacing={3} textAlign="center">
          <Heading color="teal.700" size="2xl">Resource Center</Heading>
          <Text color="gray.600" fontSize="lg">Insights and guides to help you stay healthy</Text>
        </VStack>

        <SimpleGrid columns={[1, 2, 3]} spacing={10} width="100%">
          {resources.map((item, index) => (
            <Box
              key={index}
              bg="white"
              borderRadius="2xl"
              overflow="hidden"
              boxShadow="sm"
              border="1px solid"
              borderColor="gray.100"
              transition="all 0.3s"
              _hover={{ transform: 'translateY(-5px)', boxShadow: 'xl' }}
            >
              <Image src={item.image} h="200px" w="100%" objectFit="cover" />
              <Box p={6}>
                <Tag colorScheme="teal" mb={4} borderRadius="full">{item.category}</Tag>
                <Heading size="md" mb={4} color="gray.800">{item.title}</Heading>
                <Text color="gray.600" mb={6} noOfLines={3}>{item.desc}</Text>
                <Text 
                  color="teal.500" 
                  fontWeight="bold" 
                  cursor="pointer" 
                  _hover={{ color: 'teal.600', textDecoration: 'underline' }}
                  onClick={() => {
                    toast({
                      title: "Feature coming soon",
                      description: `The detailed article for "${item.title}" will be available shortly.`,
                      status: "info",
                      duration: 3000,
                      isClosable: true,
                    });
                  }}
                >
                  Read More →
                </Text>
              </Box>
            </Box>
          ))}
        </SimpleGrid>
      </VStack>
    </Box>
  );
};
